import ContainerCard from "../ContainerCard/ContainerCard";
import SubtitleSection from "../SubtitleSection/SubtitleSection";
import TitleSection from "../TitleSection/TitleSection";
import Icon_Eye from "../../assets/Page_1/1.1_Porque/Icon_eye_full.svg";
import Glass from "../../assets/Page_1/1.1_Porque/Icon_Magnifying-glass_full.svg";
import Start from "../../assets/Page_1/1.1_Porque/Icon_star_full.svg";
import './SectionWhy.css'

const SectionWhy = () => {
  const cards = [
    {
      image:Glass ,  // ✅ Sin llaves
      title: "Detección",
      description: "Detecta cambios que suelen pasar desapercibidos",
    },
    {
      image: Icon_Eye,  // ✅ Sin llaves
      title: "Reduce molestias",
      description:
        "Reduce molestias como dolores de cabeza o visión borrosa",
    },
    {
      image: Start,  // ✅ Sin llaves
      title: "Ver con calidad",
      description: "Asegurarte de percibir el mundo con la máxima nitidez posible",
    },
  ];

  return (
    <section className="section-why">
      <TitleSection titleSection={"¿Por qué?"} />
      <SubtitleSection
        subtitleSection={
          "Realizar un test visual te ayuda a identificar señales tempranas"
        }
      />
      <div className="container">
        {cards.map((card, index) => (
          <ContainerCard
            key={index}
            img={card.image}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
    </section>
  );
};

export default SectionWhy;